import React from 'react';
import { filesize } from 'filesize';
// eslint-disable-next-line
import {
  // eslint-disable-next-line
  DownloadOutlined,
  // eslint-disable-next-line
  FileOutlined,
  // eslint-disable-next-line
  FileImageOutlined,
  // eslint-disable-next-line
  FilePdfOutlined,
  // eslint-disable-next-line
} from "@ant-design/icons";
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Row, Col } from 'antd';
import Spacer from './Spacer';

const fileIcon = (ext) => {
  switch (ext) {
    case 'pdf':
      return <FilePdfOutlined />;
    case 'jpg':
      return <FileImageOutlined />;
    case 'png':
      return <FileImageOutlined />;
    default:
      return <FileOutlined />;
  }
};

const ArticleFile = ({
  url,
  title,
  description,
  filesize: fileSize,
  download,
}) => {
  const ext = url.split('.').pop();
  console.log(ext);
  return (
    <>
      <Spacer size="md" />
      <Row>
        <Col
          xs={{
            offset: 2,
            span: 20,
          }}
          md={{ offset: 7, span: 11 }}
        >
          <div className={classNames('article-file')}>
            <div className="article-file__content">
              <h2 className="article-file__title">{title}</h2>
              <Spacer size="sm" />
              <p className="article-file__description">{description}</p>
              <Spacer size="lg" />
              <div className="article-file__bottom">
                <a href={url}>
                  <div className="article-file__dl">
                    <div className="article-file__dl-icon">
                      <DownloadOutlined />
                    </div>
                    <div className="article-file__dl-text">{download}</div>
                  </div>
                </a>
                <div className="article-file__meta">
                  {fileIcon(ext)}
                  <span className="article-file__ext">{ext}</span>
                  <span className="article-file__size">
                    {filesize(fileSize)}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>
      <Spacer size="lg" />
    </>
  );
};

ArticleFile.propTypes = {
  url: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  filesize: PropTypes.number.isRequired,
  download: PropTypes.string.isRequired,
};

export default ArticleFile;
